import { forwardRef } from 'react';

import { useMe } from '@crehana/auth';
import MyTeam from '@crehana/compass.dashlets/my-team';

import { useGetEmployeeListByCompanyAndBoss } from '../hooks/use-get-employee-list-by-company-boss/use-get-employee-list-by-company-boss';

type TMyTeamTalentWidgetProps = {
  organizationSlug: string;
};

const MyTeamTalentWidget = forwardRef<HTMLDivElement, TMyTeamTalentWidgetProps>(
  ({ organizationSlug }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const { talentUser } = useMe();
    const {
      loading: loadingMyTeam,
      data: dataMyTeam,
      error: errorMyTeam,
      refetch: refetchMyTeam,
    } = useGetEmployeeListByCompanyAndBoss(
      {
        input: {
          company_id: talentUser.company_id_talent || 0,
          leader_id: Number(talentUser.employeeId),
        },
      },
      !talentUser || !talentUser.company_id_talent || !talentUser.employeeId,
    );

    return (
      <div ref={ref} className="tw-w-full tw-h-full">
        <MyTeam
          employees={dataMyTeam}
          error={!!errorMyTeam}
          refetch={refetchMyTeam}
          isLoading={loadingMyTeam}
          organizationSlug={organizationSlug}
        />
      </div>
    );
  },
);

MyTeamTalentWidget.displayName = 'MyTeamTalentWidget';

export { MyTeamTalentWidget };
